import { createContext, useContext, useState, useCallback } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../components/ui/alert-dialog";

const ConfirmContext = createContext(null);

export const ConfirmProvider = ({ children }) => {
  const [state, setState] = useState({
    open: false,
    message: "",
    title: "Conferma",
    confirmLabel: "Elimina",
    cancelLabel: "Annulla",
    confirmClass: "bg-red-600 hover:bg-red-700",
    resolve: null,
  });

  // Firma: confirm(message) oppure confirm(message, { title, confirmLabel, confirmClass })
  const confirm = useCallback((message, options = {}) => {
    return new Promise((resolve) => {
      setState({
        open: true,
        message,
        title: options.title || "Conferma",
        confirmLabel: options.confirmLabel || "Elimina",
        cancelLabel: options.cancelLabel || "Annulla",
        confirmClass: options.confirmClass || "bg-red-600 hover:bg-red-700",
        resolve,
      });
    });
  }, []);

  const handleConfirm = () => {
    state.resolve?.(true);
    setState((s) => ({ ...s, open: false }));
  };

  const handleCancel = () => {
    state.resolve?.(false);
    setState((s) => ({ ...s, open: false }));
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <AlertDialog open={state.open} onOpenChange={(open) => { if (!open) handleCancel(); }}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{state.title}</AlertDialogTitle>
            <AlertDialogDescription>{state.message}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={handleCancel} data-testid="confirm-dialog-cancel">
              {state.cancelLabel}
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={handleConfirm}
              className={state.confirmClass}
              data-testid="confirm-dialog-ok"
            >
              {state.confirmLabel}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error("useConfirm deve essere usato dentro ConfirmProvider");
  return ctx;
};
